import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'; // Import useDispatch
import AdminHomeHelper from '../../../Components/AdminHomeHelper';

import { updateFaculty } from '../../../redux/action/adminAction'


const AdminFacultyUpdate = () => {
  const { facultyId } = useParams();
  const faculties = useSelector((store) => {
    return store.admin.allFaculty.find((faculties) => faculties._id === facultyId);
  });

// Initialize all your variables first
const initialName = faculties ? faculties.name : '';
const initialEmail = faculties ? faculties.email : '';
const initialRegistrationNumber = faculties ? faculties.registrationNumber : '';
const initialDepartment = faculties ? faculties.department : '';
const initialBranch = faculties ? faculties.branch : '';
const initialDob = faculties ? faculties.dob : '';
const initialGender = faculties ? faculties.gender : '';
const initialContactNumber = faculties ? faculties.facultyMobileNUmber : '';
const initialFatherName = faculties ? faculties.fathersName : '';
const initialFatherMobileNumber = faculties ? faculties.ParentNumber : '';
const initialAadharCard = faculties ? faculties.aadharCard : '';
const initialBloodGroup = faculties ? faculties.bloodGroup : '';
const initialReligion = faculties ? faculties.religion : '';
const initialCommunity = faculties ? faculties.community : '';
const initialMotherName = faculties ? faculties.motherName : '';
const initialFatherOccupation = faculties ? faculties.fatherOccupation : '';
const initialMotherOccupation = faculties ? faculties.motherOccupation : '';
const initialAnnualIncome = faculties ? faculties.annualIncome : '';
const initialBankAccountNumber = faculties ? faculties.bankAccountNumber : '';
const initialIfscCode = faculties ? faculties.IFSCcode : '';
const initialBankName = faculties ? faculties.bankName : '';
const initialBankBranch = faculties ? faculties.bankBranch : '';
const initialAcademicYear = faculties ? faculties.joiningYear : '';
const initialAddress = faculties ? faculties.address : '';
const initialAvatar = faculties ? faculties.avatar : '';

// Use useState to initialize your state variables
const [name, setName] = useState(initialName);
const [email, setEmail] = useState(initialEmail);
const [registrationNumber, setRegistrationNumber] = useState(initialRegistrationNumber);
const [department, setDepartment] = useState(initialDepartment);
const [branch, setBranch] = useState(initialBranch);
const [dob, setDob] = useState(initialDob);
const [gender, setGender] = useState(initialGender);
const [facultyMobileNUmber, setContactNumber] = useState(initialContactNumber);
const [fathersName, setFatherName] = useState(initialFatherName);
const [ParentNumber, setFatherMobileNumber] = useState(initialFatherMobileNumber);
const [aadharCard, setAadharCard] = useState(initialAadharCard);
const [bloodGroup, setBloodGroup] = useState(initialBloodGroup);
const [religion, setReligion] = useState(initialReligion);
const [community, setCommunity] = useState(initialCommunity);
const [motherName, setMotherName] = useState(initialMotherName);
const [fatherOccupation, setFatherOccupation] = useState(initialFatherOccupation);
const [MotherOccupation, setMotherOccupation] = useState(initialMotherOccupation);
const [annualIncome, setAnnualIncome] = useState(initialAnnualIncome);
const [bankAccountNumber, setBankAccountNumber] = useState(initialBankAccountNumber);
const [IFSCcode, setIfscCode] = useState(initialIfscCode);
const [bankName, setBankName] = useState(initialBankName);
const [bankBranch, setBankBranch] = useState(initialBankBranch);
const [joiningYear, setJoiningYear] = useState(initialAcademicYear);
const [address, setAddress] = useState(initialAddress);
const [avatar, setAvatar] = useState(initialAvatar);

// Use useDispatch after the state variables are defined
const dispatch = useDispatch();

const initialPreviewImage = faculties ? faculties.avatar : ''; // Initialize the value

const [previewImage, setPreviewImage] = useState(initialPreviewImage); // Use useState to initialize the state variable
  

  const handleUpdateFaculty = (updatedData) => {
    const confirmation = window.confirm('Are you sure you want to update this faculties?');
  
    if (confirmation) {
      dispatch(updateFaculty(facultyId, updatedData))
        .then(() => {
          alert('faculties updated successfully');
          window.location.href = '/admin/allFaculties'; // Redirect to the desired URL
        })
        .catch((error) => {
          alert('Failed to update faculties');
          console.error(error);
        });
    }
  };
  
  const imagehandler = (e) => {
    if (e.target.files && e.target.files[0]) {
        let img = e.target.files[0]
        setAvatar(img)
        console.log(img)
        const imageURL = URL.createObjectURL(img);
        setPreviewImage(imageURL);
    }
}
  
  
  return (
    <div>
   <div className="container-fluid p-0">
            <div className="d-flex">
                <div className="print-helper">
                    <AdminHomeHelper />
                </div>
                <div className="mx-1 w-100 ">
                    <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h5><Link to='/admin/allFaculties' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                        <h3> <img src="/logo192.png" width={'50px'} alt="" /> Faculty Update</h3>
                        <button  onClick={()=> window.print()} type="button" className="print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> <span className=''>Download</span></button>
                    </div>
                    <div className="col bg-light d-md-flex align-items-center justify-content-between">
                            <div className="stuData w-100">
                                <div className="row">
                                    <div className='sortDetails overflow-hidden col-md-4'>
                            <td>
                              {avatar && <img src={previewImage} alt="Current Avatar" width="100" />}
                            <form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  const formData = new FormData();
                                  formData.append("avatar", avatar);
                                  handleUpdateFaculty(formData); // Pass formData to your update function
                                }}
                              >
                                <input
                                  required
                                  className="form-control"
                                  type="file"
                                  accept=".jpg,.png,.jpeg"
                                  id="inputId"
                                  onChange={imagehandler}
                                ></input>
                                <button type='submit' className='btn btn-success'>Update</button>
                              </form>
                              </td>
                                <h5 className='bg-dark text-light p-1 w-100'>{faculties.name}</h5>
                                <div className="w-100">
                                    <h6 className='d-flex align-items-center'><img src="/image/mail.svg" alt="" className='p-1' />{faculties.email}</h6>
                                    <h6 className='d-flex align-items-center'><img src="/image/phone.svg" alt="" className='p-1' />{faculties.studentMobileNumber}</h6>
                                </div>
                            </div>
                            <div className="table-responsive">
                                   <table className="table shTable table-striped table-bordered">
                                   <tbody>
                                   <tr>
                                      <td>Name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ name: name });
                                          }}
                                        >
                                          <input
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            type="text"
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Email</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ email: email });
                                          }}
                                        >
                                          <input
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            type="text"
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Faculty Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ registrationNumber: registrationNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={registrationNumber}
                                            onChange={(e) => setRegistrationNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Date Of Birth</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ dob: dob });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={dob}
                                            onChange={(e) => setDob(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Department</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ department: department });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={department}
                                            onChange={(e) => setDepartment(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                              
                                    <tr>
                                      <td>Branch</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ branch: branch });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={branch}
                                            onChange={(e) => setBranch(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Gender</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ gender: gender });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={gender}
                                            onChange={(e) => setGender(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Contact Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ facultyMobileNUmber: facultyMobileNUmber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={facultyMobileNUmber}
                                            onChange={(e) => setContactNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Blood group</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ bloodGroup: bloodGroup });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={bloodGroup}
                                            onChange={(e) => setBloodGroup(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    
                                    <tr>
                                      <td>Religion</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ Relreligionigion: religion });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={religion}
                                            onChange={(e) => setReligion(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Community</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ community: community });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={community}
                                            onChange={(e) => setCommunity(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Aadhar number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ aadharCard: aadharCard });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={aadharCard}
                                            onChange={(e) => setAadharCard(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Permanent address</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ address: address });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Father's name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ fathersName: fathersName });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={fathersName}
                                            onChange={(e) => setFatherName(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Father's occupation</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ fatherOccupation: fatherOccupation });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={fatherOccupation}
                                            onChange={(e) => setFatherOccupation(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Mother's name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ motherName: motherName });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={motherName}
                                            onChange={(e) => setMotherName(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Mother’s occupation</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ MotherOccupation: MotherOccupation });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={MotherOccupation}
                                            onChange={(e) => setMotherOccupation(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Parent Contact Number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ ParentNumber: ParentNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={ParentNumber}
                                            onChange={(e) => setFatherMobileNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Annual family income</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ annualIncome: annualIncome });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={annualIncome}
                                            onChange={(e) => setAnnualIncome(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Bank account number</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ bankAccountNumber: bankAccountNumber });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={bankAccountNumber}
                                            onChange={(e) => setBankAccountNumber(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC code</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ IFSCcode: IFSCcode });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={IFSCcode}
                                            onChange={(e) => setIfscCode(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Bank name</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ bankName: bankName });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={bankName}
                                            onChange={(e) => setBankName(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Bank branch</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ bankBranch: bankBranch });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={bankBranch}
                                            onChange={(e) => setBankBranch(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Year of joining</td>
                                      <td>
                                        <form
                                          onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateFaculty({ joiningYear: joiningYear });
                                          }}
                                        >
                                          <input
                                            type="text"
                                            value={joiningYear}
                                            onChange={(e) => setJoiningYear(e.target.value)}
                                          />
                                          <button type='submit' className='btn btn-success'>Update</button>
                                        </form>
                                      </td>
                                    </tr>
                                                                                                  
                                    </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
};

export default AdminFacultyUpdate;